var HPEServices = require('../../base/hpe.services');
var HPEConstants = require('../../base/hpe.constants');

var CatalogCompareTrayView = require('./hpe.catalog.comparetray.view');
var CatalogCompareTrayModel = require('./hpe.catalog.comparetray.model');

/**
 * product catalog compare tray controller
 */
module.exports = (function() {

    /**
     * initialization called by hpe.core.catalog.js
     */
    function initialize() {

        var modelInit = {};
        var element = document.querySelector('.catalog-compare-tray');

        //create instance only if element exists rendered on page by AEM
        if (element) {

            //get i18n values supplied by AEM as data attributes
            modelInit.i18n = geti18nValuesFromDOM(element);

            //find additional initialization properties from DOM
            modelInit = getInstancePropertiesFromDOM(modelInit);

            //create ampersand model and view
            this.model = new CatalogCompareTrayModel(modelInit);
            this.view = new CatalogCompareTrayView({
                el: element,
                model: this.model
            });

            //event listeners
            HPEServices.subscribe(HPEConstants.catalog.COMPARE_TRAY_UPDATED, this, onListUpdated);
            HPEServices.subscribe(HPEConstants.catalog.COMPARE_TRAY_REMOVE, this, onItemRemoveFromTrayUI);
            HPEServices.subscribe(HPEConstants.catalog.COMPARE_TRAY_REMOVE_COMPLETE, this, onItemRemove);
            HPEServices.subscribe(HPEConstants.catalog.COMPARE_TRAY_ADD, this, onItemAdd);
            HPEServices.subscribe(HPEConstants.catalog.CATALOG_RESULTS_UPDATED, this, onCatalogResultsRendered);
            HPEServices.subscribe(HPEConstants.catalog.SCROLLING_RENDER_UPDATE, this, onCatalogScrollingUpdate);
            HPEServices.subscribe(HPEConstants.dynamictabcontainer.CHANGE, this, onTabContainerTabChange);
            HPEServices.subscribe(HPEConstants.dynamictabcontainer.MOBILE_OPEN_CLOSE, this, onTabContainerMobileViewOpenClose);
        }
    }

    /**
     * determine details about this compare tray instance via DOM
     * @param {object} props object to mutate with additional properties
     * @return {object} updated object
     */
    function getInstancePropertiesFromDOM(props) {

        var activePDPTab = document.querySelector('.dynamic-tab-container-tab.active');

        //determine if this is a PDP instance
        props.isPDPInstance = !!(document.querySelector('.hpe-product-detail-page'));

        //if a PDP instance, note the id of the starting tab
        if (props.isPDPInstance) {

            props.pdpTabID = activePDPTab && activePDPTab.getAttribute('data-instance-class');

            //tray not entitled to appear on initial PDP unless tab is of type models
            props.isEntitled = !!(props.pdpTabID && HPEConstants.componentclass[props.pdpTabID] === HPEConstants.componentclass.MODELS);

        //compare tray is always entitled to appear if not on PDP
        } else {
            props.isEntitled = true;
        }

        return props;
    }

    /**
     * given an element, return an object with key/value pairs found as data-i18n attributes on that element
     * @param {object} element HTMLSelector of the element to evaluate
     * @return {object} object with key value pairs of found values
     */
    function geti18nValuesFromDOM(element) {

        var keys = ['item', 'items', 'compare', 'clear', 'remove', 'updated', 'new'];
        var values = {};

        keys.forEach(function(key) {
            var value = element.getAttribute('data-i18n-' + key);
            if (value) {
                values[key] = value;
            }
        });

        return values;
    }

    /**
     * handle compare tray list updated event
     */
    function onListUpdated() {
        this.view.update();
    }

    /**
     * handle compare tray item add event
     * @param {string} item oid of the item to add
     */
    function onItemAdd(item) {
        this.model.itemAdd(item);
    }

    /**
     * handle compare tray item remove complete event
     * @param {string} item oid of the item to remove
     */
    function onItemRemove(item) {
        this.model.itemRemove(item);
    }

    /**
     * handle compare tray remove event
     * @param {string} item oid of the item to remove
     */
    function onItemRemoveFromTrayUI(item) {
        this.model.setItemRemoveFromUIFlag(item);
    }

    /**
     * handle event from productlist that content has (re)rendered
     */
    function onCatalogResultsRendered() {
        if (!this.model.isInited) {
            this.view.initializeScrollingBehavior();
        } else {
            this.view.update();
        }
    }

    /**
     * handle productlist scrolling event
     */
    function onCatalogScrollingUpdate() {
        this.view.update();
    }

    /**
     * handle dynamic tab container change event
     * @param {string} id key constant string id of the newly active tab
     */
    function onTabContainerTabChange(id) {
        //do not show compare tray on pdp/dynamic tab page unless models tab is active
        //if in mobile breakpoint, the open/close mobile event handler manages entitlement
        if (!this.model.isMobile) {
            this.model.isEntitled = !!(id && HPEConstants.componentclass[id] === HPEConstants.componentclass.MODELS);
            this.view.update();
        }
    }

    /**
     * handle dynamic tab container mobile open/close event
     * @param {object} e event object with id and isOpen keys
     */
    function onTabContainerMobileViewOpenClose(e) {
        //compare tray is entitled to be open in mobile view if current tab is 'models'
        //and that tab is 'open'
        if (e && e.id && HPEConstants.componentclass[e.id] === HPEConstants.componentclass.MODELS) {
            this.model.isEntitled = e.isOpen;
            this.view.update();
        }
    }

    /**
     * public methods
     */
    return {
        initialize: initialize
    };

})();
